/* eslint-disable sort-keys */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-cycle */
import React from 'react'

import { Image } from '../../components'
import { Content } from '../../components/Typography'
import { SectionContainer } from '../../layouts'
import { ContentParser } from '../../utils/helpers'
import {
  contentContainer,
  divider,
  experienceContent,
  experienceContentContainer,
  experienceImage,
  experienceImageContainer,
  experienceItem,
  experienceItemsContainer,
  experienceItemTitle,
  extraKickerStyling,
  // reverseImage,
  reverseItem,
  sectionColor,
} from './ExperienceSection.module.css'

const NewExperienceSection = ({ slice }) => {
  const usps = ContentParser(slice, 'experienceusp')
  const { experiencekicker } = slice

  return (
    <SectionContainer
      extraClassName={sectionColor}
      extraContentClassName={contentContainer}
      extraHeadingClassName={extraKickerStyling}
      heading={experiencekicker}
      withHeader
    >
      <div className={experienceItemsContainer}>
        {!!usps.length && (
          <>
            <div className={`${experienceItem}`}>
              <div className={experienceContentContainer}>
                {usps && usps[0] && (
                  <p className={experienceItemTitle}>{usps[0]?.usptitle}</p>
                )}
                {usps && usps[0] && (
                  <Content
                    extraClassName={experienceContent}
                    renderContent={usps[0]?.uspcontent}
                  />
                )}
                {usps && usps[0] && <div className={divider} />}
                {usps && usps[1] && (
                  <p className={experienceItemTitle}>{usps[1]?.usptitle}</p>
                )}
                {usps && usps[1] && (
                  <Content
                    extraClassName={experienceContent}
                    renderContent={usps[1]?.uspcontent}
                  />
                )}
              </div>
              {usps && usps[0] && (
                <div className={experienceImageContainer}>
                  <Image
                    alt={usps[0]?.uspimage?.node.altText || 'Kliniken Image'}
                    className={experienceImage}
                    loading="lazy"
                    quality={85}
                    src={usps[0]?.uspimage?.node.localFile.childImageSharp}
                  />
                </div>
              )}
            </div>
            <div className={`${experienceItem} ${reverseItem}`}>
              <div className={experienceContentContainer}>
                {usps && usps[2] && (
                  <p className={experienceItemTitle}>{usps[2]?.usptitle}</p>
                )}
                {usps && usps[2] && (
                  <Content
                    extraClassName={experienceContent}
                    renderContent={usps[2]?.uspcontent}
                  />
                )}
                {usps && usps[2] && <div className={divider} />}
                {usps && usps[3] && (
                  <p className={experienceItemTitle}>{usps[3]?.usptitle}</p>
                )}
                {usps && usps[3] && (
                  <Content
                    extraClassName={experienceContent}
                    renderContent={usps[3]?.uspcontent}
                  />
                )}
              </div>
              {usps && usps[2] && (
                <div className={experienceImageContainer}>
                  <Image
                    alt={usps[2]?.uspimage?.node.altText || 'Kliniken Image'}
                    className={experienceImage}
                    loading="lazy"
                    quality={85}
                    src={usps[2]?.uspimage?.node.localFile.childImageSharp}
                  />
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </SectionContainer>
  )
}

export default NewExperienceSection
